import React,{ Component } from 'react';
import {AgGridReact} from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

export default class TableRow extends Component {
    constructor(props){
    	super(props);
    	this.state = {
          text: 'Sync my data',   
      };
      this.aggridRef = React.createRef();
      this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
      this.onBtExport = this.onBtExport.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.setState({ text: 'Sync my data' });
        }
    }

    onPageSizeChanged(e) {
      let value = e.target.value;
      this.setState({ pageSize: value });
      this.aggridRef.current.api.paginationSetPageSize(Number(value));
    };

    onBtExport(){
      this.aggridRef.current.api.exportDataAsExcel();
    };

    render() {
        const { rows } = this.props;
        const perPage = 10;
        if (rows && rows.rowData && rows.rowData.length > 0) {
            return(
              <>
                <div className="ag-theme-balham" style={{height: rows.rowData.length >= 2 ? '567px': '220px', width: '100%'}} >
                  {rows.rowData.length >= 10 && (
                    <div className="example-header">
                      Page Size: &nbsp;
                      <select onChange={this.onPageSizeChanged} id="page-size" value={this.pageSize}>
                        <option value="10">
                          10
                        </option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>
                  )}
                  
                
                  <AgGridReact
                      ref={this.aggridRef}
                      pagination={true}
                      rowHeight={50}
                      paginationPageSize={perPage}
                      columnDefs={rows.columnDefs}
                      rowData={rows.rowData}>
                  </AgGridReact>
                </div>
              </>
            );
        }

        return null;
  }
}
